/* KT Euro Plate Builder - see sections/kt-euro-builder.liquid */
(function () {
function initEuroBuilder(root) {
  if (root.dataset.ebReady) return; root.dataset.ebReady = '1';
  var KIT_LABEL = root.dataset.kitLabel || 'Euro plate set';
  var ROOT_URL = (root.dataset.rootUrl || '/').replace(/\/$/, '');

  /* ---------- Catalogue rules ----------
     Plates are found by their BG product code (from the SKU): [series][finish]EM[size][insert],
     e.g. NBSEMR4 = Nexus Metal, Brushed Steel, 4-module; PCDBSEMS2W = Evolve, Brushed Steel,
     2-module, white insert. Which series are shown, and the names of series and finishes,
     come from the section settings in the theme editor - no product is listed in code. */
  function parseMap(str) {
    var out = []; String(str || '').split(/[\n,;]+/).forEach(function (line) {
      var m = line.split('='); if (m.length < 2) return;
      var k = m[0].trim().toUpperCase(), v = m.slice(1).join('=').trim(); if (k && v) out.push({ k: k, v: v });
    }); return out;
  }
  var SERIES = parseMap(root.dataset.series);
  var FINISH_NAMES = {}; parseMap(root.dataset.finishCodes).forEach(function (e) { FINISH_NAMES[e.k] = e.v; });
  var FRONT_KEY = String(root.dataset.frontKeyword == null ? 'front view' : root.dataset.frontKeyword).trim().toLowerCase();
  var ENABLED = String(root.dataset.ranges || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  var PLATE_REST = /^([A-Z]{2})?EM(S1|S2|R4|8)([BW]?)$/;
  function seriesOf(code) {
    var best = null; SERIES.forEach(function (s) { if (code.indexOf(s.k) === 0 && (!best || s.k.length > best.k.length)) best = s; });
    return best;
  }
  function finishName(code, title) {
    if (!code) return 'Standard finish';
    if (FINISH_NAMES[code]) return FINISH_NAMES[code];
    var m = String(title || '').match(/(Polished|Brushed|Satin|Matt|Black|Antique|Pearl\w*)\s+\w+/i);
    return m ? m[0] : code;
  }
  function plateLabel(p) { return (p.fcode ? p.finishName : '') + (p.insert ? ' (' + COLOURS[p.insert].toLowerCase() + ' insert)' : ''); }
  function sizeLabel(sz) { return sz === 8 ? '8 spaces (2 × 4)' : sz + ' space' + (sz > 1 ? 's' : ''); }
  function rowsFor(sz) { return sz === 8 ? 2 : 1; }
  var SIZE = { S1: 1, S2: 2, R4: 4, '8': 8 };
  /* Euro modules: base code (without colour letter) -> [category, name, spaces].
     A space is 25x50mm. Half-module blanks come in packs of two = 1 space. */
  var MODULES = {
    EMRJ45C6: ['Data', 'Cat6 RJ45 data outlet', 1],
    EMRJ45C5E: ['Data', 'Cat5e RJ45 data outlet', 1],
    EMBTMS: ['Telephone', 'BT master telephone socket (screw)', 1],
    EMBTMI: ['Telephone', 'BT master telephone socket (IDC)', 1],
    EMBTSS: ['Telephone', 'BT secondary telephone socket (screw)', 1],
    EMBTSI: ['Telephone', 'BT secondary telephone socket (IDC)', 1],
    EMRJ11: ['Telephone', 'RJ11 telephone outlet', 1],
    EMNSTV: ['TV & audio', 'Coaxial TV outlet (unscreened)', 1],
    EMNSITV: ['TV & audio', 'Isolated coaxial TV outlet (unscreened)', 1],
    EMNSSAT: ['TV & audio', 'Satellite outlet (unscreened)', 1],
    EMSAT: ['TV & audio', 'Satellite outlet (screened)', 1],
    EMTVF: ['TV & audio', 'Coaxial TV outlet female (screened)', 1],
    EMTVM: ['TV & audio', 'Coaxial TV outlet male (screened)', 1],
    EMTVFM: ['TV & audio', 'TV + FM diplex outlet', 2],
    EMTVSAT: ['TV & audio', 'TV + satellite diplex outlet', 2],
    EMTVFMSAT: ['TV & audio', 'TV + FM + satellite triplex outlet', 2],
    EMTVFMSAT2: ['TV & audio', 'TV + FM + 2x satellite quadplex outlet', 2],
    EMRCA2: ['TV & audio', 'Twin RCA (phono) outlet', 1],
    EMHDMI: ['TV & audio', 'HDMI 1.4 outlet', 2],
    EMUKS: ['Power', '13A UK unswitched socket', 2],
    EMUNV: ['Power', 'Universal unswitched socket', 2],
    EMSCHS: ['Power', '16A Schuko unswitched socket', 2],
    EMEUS: ['Power', '16A 2-pin Euro unswitched socket', 2],
    EM5AS: ['Power', '5A round pin unswitched socket', 2],
    EM2AS: ['Power', '2A round pin unswitched socket', 2],
    EMKYCS: ['Power', 'Key controlled socket', 2],
    EMKYSWS: ['Power', 'Key switched socket', 2],
    EMFUSE: ['Power', 'Fuse holder module', 1],
    EMUSB3: ['USB charging', 'Dual USB-A charger 3.1A', 2],
    EMUSBAC45: ['USB charging', 'USB-A + USB-C 45W charger', 2],
    EMSW12: ['Switches & dimmers', '20AX 2-way switch', 1],
    EMSW13: ['Switches & dimmers', '10AX intermediate switch', 1],
    EMSW30: ['Switches & dimmers', '20A double pole switch', 1],
    EMSW12KY: ['Switches & dimmers', '2-way secret key switch', 1],
    EMSW12EL: ['Switches & dimmers', 'Emergency lighting test key switch', 1],
    EMSW30KY: ['Switches & dimmers', '20A DP secret key switch', 1],
    EMTDM: ['Switches & dimmers', 'Master touch LED dimmer', 1],
    EMTDS: ['Switches & dimmers', 'Slave touch LED dimmer', 1],
    EMFO: ['Cable outlets', 'Brush flex / cable outlet', 2],
    EM45AFO: ['Cable outlets', '45A flex outlet', 2],
    EMBLK: ['Blank', 'Half-module blanks (pack of 2)', 1],
    EMBLK1: ['Blank', 'Single blank module', 1]
  };
  var CAT_ORDER = ['Data', 'Telephone', 'TV & audio', 'Power', 'USB charging', 'Switches & dimmers', 'Cable outlets', 'Blank', 'Other'];
  var COLOURS = { B: 'Black', G: 'Grey', W: 'White' };
  var COLOUR_SWATCH = { B: '#262626', G: '#8d9093', W: '#fafafa' };

  /* ---------- State ---------- */
  var state = { open: 'range', range: null, finish: null, size: null, colour: 'all', cat: 'all', q: '', picks: [], kitQty: 1, plates: [], modules: [] };
  /* picks: ordered list of module ids (one entry per unit) -> slot order */

  var $ = function (s) { return root.querySelector(s); };
  var els = {
    ranges: $('[data-eb-ranges]'), rangeLabel: $('[data-eb-range-label]'), finishes: $('[data-eb-finishes]'), sizes: $('[data-eb-sizes]'),
    colours: $('[data-eb-colours]'), cats: $('[data-eb-cats]'), search: $('[data-eb-search]'), mods: $('[data-eb-mods]'),
    preview: $('[data-eb-preview]'), capacity: $('[data-eb-capacity]'), bar: $('[data-eb-bar]'), fill: $('[data-eb-fill]'),
    lines: $('[data-eb-lines]'), kqOut: $('[data-eb-kq-out]'), total: $('[data-eb-total]'), msg: $('[data-eb-msg]'),
    add: $('[data-eb-add]'), viewcart: $('[data-eb-viewcart]'), clear: $('[data-eb-clear]'),
    picked: $('[data-eb-picked]'), progress: $('[data-eb-progress]'), mbar: $('[data-eb-mbar]'), mtotal: $('[data-eb-mtotal]'), madd: $('[data-eb-madd]')
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(p) { return '£' + (p / 100).toFixed(2); }
  function img(src, alt, w) {
    if (!src) return '<span class="kt-eb__noimg"></span>';
    return '<img src="' + esc(src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 120)) + '" alt="' + esc(alt) + '" loading="lazy">';
  }
  function codeOf(p) {
    var sku = (p.variants[0] && p.variants[0].sku) || '';
    var c = sku.replace(/^BG-/i, '').replace(/-Shopify-SA_1$|-SA_1$|-1$/i, '').toUpperCase();
    if (c && /^[A-Z0-9]+$/.test(c)) return c;
    if (c) return ''; /* SKUs with extra parts (e.g. multi-packs) are not single plates or modules */
    var m = p.title.match(/\b((?:EM|N|F|PCD)[A-Z0-9]{3,14})\b/);
    return m ? m[1].toUpperCase() : '';
  }

  /* Any Euro module not in the table above is still picked up automatically: its size,
     type and name are read from the product's own title, description and tags. */
  function guessModule(p) {
    var t = p.title + ' ' + (p.tags || []).join(' '), b = String(p.body_html || '').replace(/<[^>]+>/g, ' ');
    var sp = 1, m = t.match(/(\d)\s*Module/i);
    if (m) sp = Number(m[1]);
    else if (/50\s*x\s*50/i.test(t + ' ' + b) || /\b(two|2)[ -]modules? wide/i.test(b)) sp = 2;
    var cat = /rj45|cat ?5|cat ?6|data/i.test(t) ? 'Data' : /telephone|rj11|\bbt\b/i.test(t) ? 'Telephone' :
      /tv|coax|satellite|hdmi|rca|audio|fm/i.test(t) ? 'TV & audio' : /usb/i.test(t) ? 'USB charging' :
      /switch|dimmer/i.test(t) ? 'Switches & dimmers' : /socket|fuse/i.test(t) ? 'Power' :
      /flex|cable|outlet/i.test(t) ? 'Cable outlets' : /blank/i.test(t) ? 'Blank' : 'Other';
    var name = p.title.replace(/^BG\s+(Electrical\s+|Nexus\s+)?/i, '').replace(/\b(EM[A-Z0-9]+)\b/, '').replace(/\b(Black|Grey|White)\b/gi, '').replace(/[-|]+/g, ' ').replace(/\s+/g, ' ').trim();
    return [cat, name, sp];
  }

  /* ---------- Normalise catalogue ---------- */
  function normalise(products) {
    products.forEach(function (p) {
      var v = p.variants && p.variants[0];
      if (!v) return;
      var code = codeOf(p);
      var base = { pid: p.id, vid: v.id, title: p.title, code: code, price: Math.round(parseFloat(v.price) * 100), available: v.available !== false,
                   image: (p.images && p.images[0] && p.images[0].src) || '', images: (p.images || []).map(function (im) { return im.src; }).filter(Boolean), handle: p.handle };
      var ser = /^EM/.test(code) ? null : seriesOf(code), pm = ser && code.slice(ser.k.length).match(PLATE_REST);
      if (pm && (!ENABLED.length || ENABLED.indexOf(ser.v.toLowerCase()) > -1 || ENABLED.indexOf(ser.k.toLowerCase()) > -1)) {
        base.range = ser.k; base.rangeName = ser.v; base.fcode = pm[1] || ''; base.insert = pm[3] || '';
        base.finish = (pm[1] || 'STD') + base.insert; base.finishName = finishName(pm[1] || '', p.title); base.size = SIZE[pm[2]];
        state.plates.push(base);
      }
      /* Module codes end in the insert colour (B/G/W); a few modules (e.g. brush outlets)
         come in one colour only and have no colour letter - they are offered with every colour. */
      var mm = code.match(/^(EM[A-Z0-9]+?)([BGW])?$/);
      if (mm && !/\+/.test(code)) {
        var def = MODULES[mm[1]] || guessModule(p);
        /* the product's own description wins when it states its size, e.g. "Size: 4M" */
        var sz = String(p.body_html || '').replace(/<[^>]+>/g, ' ').match(/Size:\s*(\d)\s*M\b/i);
        base.base = mm[1]; base.colour = mm[2] || ''; base.cat = def[0]; base.name = def[1]; base.spaces = sz ? Number(sz[1]) : def[2];
        state.modules.push(base);
      }
    });
    state.modules.sort(function (a, b) {
      return (CAT_ORDER.indexOf(a.cat) - CAT_ORDER.indexOf(b.cat)) || a.name.localeCompare(b.name) || a.colour.localeCompare(b.colour);
    });
  }

  /* ---------- Helpers ---------- */
  function rangesAvailable() { return SERIES.map(function (s) { return s.k; }).filter(function (k) { return state.plates.some(function (p) { return p.range === k; }); }); }
  function platesOf(range, finish) { return state.plates.filter(function (p) { return p.range === range && (!finish || p.finish === finish); }); }
  function finishesFor(range) { var f = []; state.plates.forEach(function (p) { if (p.range === range && f.indexOf(p.finish) === -1) f.push(p.finish); }); return f; }
  function plateFor(range, finish, size) { return state.plates.find(function (p) { return p.range === range && p.finish === finish && p.size === size; }); }
  function currentPlate() { return state.range && state.finish && state.size ? plateFor(state.range, state.finish, state.size) : null; }
  function modById(id) { return state.modules.find(function (m) { return String(m.vid) === String(id); }); }
  function usedSpaces() { return state.picks.reduce(function (s, id) { var m = modById(id); return s + (m ? m.spaces : 0); }, 0); }
  function capacity() { var p = currentPlate(); return p ? p.size : 0; }
  function sizesOf(range, finish) { var s = []; platesOf(range, finish).forEach(function (p) { if (s.indexOf(p.size) === -1) s.push(p.size); }); return s.sort(function (a, b) { return a - b; }); }
  function finishesOf(range) { var f = []; platesOf(range).forEach(function (p) { if (f.indexOf(p.finish) === -1) f.push(p.finish); }); return f; }
  function countOf(id) { return state.picks.filter(function (x) { return String(x) === String(id); }).length; }
  /* Default insert colour: the plate's own insert colour if its code has one (Evolve B/W),
     otherwise black for dark/warm finishes and grey for silver ones, judged from the photo name. */
  function defaultColour() {
    var p = currentPlate() || platesOf(state.range, state.finish)[0];
    if (!p) return 'all';
    if (p.insert) return p.insert;
    var name = p.fcode ? p.finishName : p.rangeName;
    if (/white|moulded|part m/i.test(name)) return 'W';
    return /black|brass|bronze|copper|nickel|gold|blue|grey/i.test(name) ? 'B' : 'G';
  }

  /* ---------- Render: plate step ---------- */
  function minPrice(list) { return list.reduce(function (m, p) { return Math.min(m, p.price); }, 1e12); }
  /* Guided steps: only the step being worked on is open; finished steps collapse to a
     one-line summary with a Change button. Ranges with a single finish skip the finish step. */
  var STEPS = ['range', 'finish', 'size', 'modules'];
  function stepValue(st) {
    var p0 = platesOf(state.range, state.finish)[0];
    if (st === 'range') return state.range ? platesOf(state.range)[0].rangeName : '';
    if (st === 'finish') return p0 ? (p0.fcode ? plateLabel(p0) : 'Standard finish') : '';
    if (st === 'size') return currentPlate() ? sizeLabel(state.size) : '';
    if (st === 'modules') return currentPlate() ? usedSpaces() + ' / ' + capacity() + ' spaces filled' : '';
    return '';
  }
  function stepAvailable(st) {
    if (st === 'range') return true;
    if (st === 'finish' || st === 'size') return !!state.range;
    return !!currentPlate();
  }
  function openStep(st) { if (!stepAvailable(st)) return; state.open = st; renderSteps(); var el = root.querySelector('[data-step="' + st + '"]'); if (el && el.getBoundingClientRect().top < 0) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  function renderSteps() {
    var single = state.range && finishesOf(state.range).length === 1;
    var idx = 0;
    root.querySelectorAll('[data-step]').forEach(function (sec) {
      var st = sec.dataset.step, val = stepValue(st), open = state.open === st;
      if (!(st === 'finish' && single)) { idx++; var num = sec.querySelector('.kt-eb__num'); if (num) num.textContent = idx; }
      sec.classList.toggle('is-open', open);
      sec.classList.toggle('is-done', !!val && !open);
      sec.classList.toggle('is-locked', !stepAvailable(st));
      sec.hidden = st === 'finish' && single;
      var sel = sec.querySelector('[data-eb-sel]'); if (sel) sel.textContent = val || '';
    });
    els.progress.innerHTML = STEPS.filter(function (st) { return !(st === 'finish' && single); }).map(function (st, i) {
      var val = stepValue(st), cls = state.open === st ? ' is-current' : (val ? ' is-done' : '');
      var title = { range: 'Range', finish: 'Finish', size: 'Plate size', modules: 'Modules' }[st];
      return '<button type="button" class="kt-eb__prog' + cls + '" data-goto="' + st + '"' + (stepAvailable(st) ? '' : ' disabled') + '><i>' + (val && state.open !== st ? '✓' : i + 1) + '</i><span><b>' + title + '</b><small>' + esc(val || (st === 'range' ? 'Choose' : '—')) + '</small></span></button>';
    }).join('');
    els.progress.querySelectorAll('[data-goto]').forEach(function (b) { b.addEventListener('click', function () { openStep(b.dataset.goto); }); });
  }
  function renderRanges() {
    els.ranges.innerHTML = rangesAvailable().map(function (rk) {
      var list = platesOf(rk), name = list[0].rangeName, fins = finishesOf(rk);
      var hero = list.slice().sort(function (a, b) { return b.size - a.size; })[0];
      return '<button type="button" class="kt-eb__range' + (state.range === rk ? ' is-active' : '') + '" data-range="' + esc(rk) + '">' +
        '<span class="kt-eb__range-img">' + img(hero.image, name, 360) + '</span>' +
        '<span class="kt-eb__range-body"><strong>' + esc(name) + '</strong>' +
        '<small>' + (fins.length > 1 ? fins.length + ' finishes' : 'Single finish') + ' &middot; ' + sizesOf(rk).length + ' sizes</small>' +
        '<em>from ' + money(minPrice(list)) + '</em></span></button>';
    }).join('');
    els.ranges.querySelectorAll('[data-range]').forEach(function (b) {
      b.addEventListener('click', function () {
        var changed = state.range !== b.dataset.range;
        state.range = b.dataset.range; ensureFinish();
        var multi = finishesOf(state.range).length > 1;
        state.open = (multi && (changed || !state.finish)) ? 'finish' : (currentPlate() ? 'modules' : 'size');
        afterPlateChange();
      });
    });
  }
  /* Keep the customer's choices where possible: same finish name and size if the new range has them,
     otherwise the closest size that still holds the modules already chosen. */
  function ensureFinish() {
    var fs = finishesOf(state.range), list = platesOf(state.range);
    if (fs.indexOf(state.finish) === -1) {
      var oldName = state.finishName, same = list.find(function (p) { return p.fcode && p.finishName === oldName; });
      state.finish = same ? same.finish : (fs.length === 1 ? fs[0] : null);
    }
    fitSize();
  }
  function fitSize() {
    if (!state.size || !state.finish) return;
    if (plateFor(state.range, state.finish, state.size)) return;
    var need = usedSpaces();
    var alt = sizesOf(state.range, state.finish).map(function (sz) { return plateFor(state.range, state.finish, sz); }).filter(function (p) { return p && p.available && p.size >= need; });
    state.size = alt.length ? alt[0].size : null;
  }
  function thumbFor(f) { var list = platesOf(state.range, f).sort(function (a, b) { return a.size - b.size; }); return list[0] ? list[0].image : ''; }
  function renderFinishes() {
    if (!state.range) { els.finishes.innerHTML = '<p class="kt-eb__note">Choose a range first.</p>'; return; }
    var fs = finishesOf(state.range);
    els.finishes.innerHTML = fs.map(function (f) {
      var ps = platesOf(state.range, f), p0 = ps[0], inStock = ps.some(function (p) { return p.available; });
      var sizes = sizesOf(state.range, f).map(function (sz) { var q = ps.find(function (p) { return p.size === sz; }); return '<i class="' + (q.available ? '' : 'is-off') + '" title="' + sizeLabel(sz) + (q.available ? ' in stock' : ' out of stock') + '">' + sz + '</i>'; }).join('');
      return '<button type="button" class="kt-eb__swatch' + (state.finish === f ? ' is-active' : '') + (inStock ? '' : ' is-out') + '" data-finish="' + esc(f) + '" aria-pressed="' + (state.finish === f) + '">' +
        '<span class="kt-eb__swatch-photo">' + img(thumbFor(f), p0.finishName, 300) + '</span>' +
        '<strong>' + esc(p0.finishName) + '</strong>' + (p0.insert ? '<small>' + COLOURS[p0.insert] + ' insert</small>' : '<small>from ' + money(minPrice(ps)) + '</small>') +
        '<span class="kt-eb__swatch-sizes">' + sizes + '</span></button>';
    }).join('');
    els.finishes.querySelectorAll('[data-finish]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.finish = b.dataset.finish; fitSize();
        state.open = currentPlate() ? 'modules' : 'size';
        afterPlateChange();
      });
    });
  }
  function renderSizes() {
    if (!state.range || !state.finish) { els.sizes.innerHTML = '<p class="kt-eb__note">Choose a ' + (state.range ? 'finish' : 'range') + ' first.</p>'; els.picked.hidden = true; return; }
    var html = sizesOf(state.range, state.finish).map(function (sz) {
      var p = plateFor(state.range, state.finish, sz);
      var off = !p.available, tooSmall = usedSpaces() > sz;
      return '<button type="button" class="kt-eb__sizecard' + (state.size === sz ? ' is-active' : '') + '" data-size="' + sz + '"' + (off ? ' disabled' : '') + ' title="' + esc(p.title) + '">' +
        '<span class="kt-eb__sizecard-img">' + img(p.image, p.title, 300) + '</span>' +
        '<strong>' + sizeLabel(sz) + '</strong><small>BG ' + esc(p.code) + '</small>' +
        '<b>' + (off ? 'Out of stock' : money(p.price)) + '</b>' + (tooSmall && !off ? '<em>Too small for your modules</em>' : '') + '</button>';
    }).join('');
    els.sizes.innerHTML = html ? '<div class="kt-eb__sizegrid">' + html + '</div>' : '<p class="kt-eb__note">No plates found for this finish.</p>';
    els.sizes.querySelectorAll('[data-size]').forEach(function (b) {
      b.addEventListener('click', function () { state.size = Number(b.dataset.size); state.open = 'modules'; afterPlateChange(); });
    });
    els.picked.hidden = true;
  }
  function afterPlateChange() {
    var p0 = platesOf(state.range, state.finish)[0];
    state.finishName = p0 && p0.fcode ? p0.finishName : state.finishName;
    if (!state.colourTouched) state.colour = defaultColour();
    renderPlateStep(); renderFilters(); renderAll();
  }
  function renderPlateStep() {
    renderRanges(); renderFinishes(); renderSizes(); renderSteps();
  }

  /* ---------- Render: module step ---------- */
  function renderFilters() {
    var cols = ['all', 'B', 'G', 'W'];
    els.colours.innerHTML = cols.map(function (c) {
      var label = c === 'all' ? 'All colours' : COLOURS[c];
      var dot = c === 'all' ? '' : '<span class="kt-eb__dot" style="background:' + COLOUR_SWATCH[c] + '"></span>';
      return '<button type="button" class="kt-eb__chip' + (state.colour === c ? ' is-active' : '') + '" data-colour="' + c + '">' + dot + label + '</button>';
    }).join('');
    els.colours.querySelectorAll('[data-colour]').forEach(function (b) {
      b.addEventListener('click', function () { state.colour = b.dataset.colour; state.colourTouched = true; renderFilters(); renderModules(); });
    });
    var cats = ['all'].concat(CAT_ORDER.filter(function (c) { return state.modules.some(function (m) { return m.cat === c; }); }));
    els.cats.innerHTML = cats.map(function (c) {
      return '<button type="button" class="kt-eb__chip kt-eb__chip--dark' + (state.cat === c ? ' is-active' : '') + '" data-cat="' + esc(c) + '">' + (c === 'all' ? 'All' : esc(c)) + '</button>';
    }).join('');
    els.cats.querySelectorAll('[data-cat]').forEach(function (b) {
      b.addEventListener('click', function () { state.cat = b.dataset.cat; renderFilters(); renderModules(); });
    });
  }
  function visibleModules() {
    var q = state.q.toLowerCase();
    return state.modules.filter(function (m) {
      if (state.colour !== 'all' && m.colour && m.colour !== state.colour) return false;
      if (state.cat !== 'all' && m.cat !== state.cat) return false;
      if (q && (m.name + ' ' + m.code + ' ' + m.title + ' ' + m.cat).toLowerCase().indexOf(q) === -1) return false;
      return true;
    });
  }
  function renderModules() {
    var list = visibleModules();
    var cap = capacity(), used = usedSpaces();
    if (!list.length) { els.mods.innerHTML = '<p class="kt-eb__note">No modules match these filters.</p>'; return; }
    els.mods.innerHTML = list.map(function (m) {
      var n = countOf(m.vid);
      var canAdd = m.available && cap > 0 && used + m.spaces <= cap;
      return '<div class="kt-eb__mod' + (n ? ' is-picked' : '') + (m.available ? '' : ' is-out') + '" data-mod="' + m.vid + '">' +
        '<div class="kt-eb__mod-top">' + img(m.image, m.title, 120) +
          '<div><span class="kt-eb__cat">' + esc(m.cat) + '</span><div class="kt-eb__mod-name">' + esc(m.name) + (m.colour ? ' &ndash; ' + COLOURS[m.colour] : '') + '</div>' +
          '<span class="kt-eb__mod-code">BG ' + esc(m.code) + '</span></div></div>' +
        '<div class="kt-eb__mod-foot"><span><b>' + money(m.price) + '</b>' + m.spaces + ' space' + (m.spaces > 1 ? 's' : '') + (m.available ? '' : ' &middot; out of stock') + '</span>' +
          '<span class="kt-eb__qty"><button type="button" data-minus' + (n ? '' : ' disabled') + ' aria-label="Remove one ' + esc(m.name) + '">&minus;</button>' +
          '<output>' + n + '</output>' +
          '<button type="button" data-plus' + (canAdd ? '' : ' disabled') + ' aria-label="Add one ' + esc(m.name) + '" title="' + (cap ? (canAdd ? 'Add' : (m.available ? 'Not enough free space on this plate' : 'Out of stock')) : 'Choose a plate size first') + '">+</button></span></div></div>';
    }).join('');
    els.mods.querySelectorAll('[data-mod]').forEach(function (row) {
      var id = row.dataset.mod;
      row.querySelector('[data-plus]').addEventListener('click', function () { addPick(id); });
      row.querySelector('[data-minus]').addEventListener('click', function () { removePick(id); });
    });
  }
  /* On double-stack plates a module cannot straddle the two rows. */
  function straddles(picks) {
    var p = currentPlate(); if (!p || rowsFor(p.size) === 1) return null;
    var perRow = p.size / rowsFor(p.size), used = 0, bad = null;
    picks.forEach(function (id) { var m = modById(id); if (!m || bad) return; if ((used % perRow) + m.spaces > perRow) bad = m; used += m.spaces; });
    return bad;
  }
  function addPick(id) {
    var m = modById(id);
    if (!m || !m.available || !capacity() || usedSpaces() + m.spaces > capacity()) return;
    var at = state.insertAt, next = state.picks.slice();
    if (at != null && at <= next.length) next.splice(at, 0, String(id)); else { at = next.length; next.push(String(id)); }
    var bad = straddles(next);
    if (bad) { showMsg('A ' + bad.spaces + '-space module can’t sit across the two rows of this plate. Add a 1-space module or blank first, or delete a module to make room.', 'err', true); return; }
    state.picks = next; state.flash = at;
    state.insertAt = null; clearMsg(); renderAll();
  }
  /* Delete one specific module from the plate. The freed position is remembered,
     so the next module the customer picks goes straight back into that position. */
  function deleteAt(i) {
    if (i < 0 || i >= state.picks.length) return;
    var m = modById(state.picks[i]);
    state.picks.splice(i, 1);
    state.insertAt = state.picks.length ? i : null;
    renderAll();
    if (m && state.picks.length) showMsg(m.name + ' removed. Choose a replacement module and it will go into the same position.', '', true);
  }
  function removePick(id) {
    var i = state.picks.lastIndexOf(String(id));
    if (i > -1) { state.picks.splice(i, 1); if (state.insertAt != null && state.insertAt > i) state.insertAt--; }
    if (state.insertAt != null && state.insertAt > state.picks.length) state.insertAt = null;
    clearMsg(); renderAll();
  }

  /* ---------- Summary ---------- */
  /* ---------- Live photo composite: real module photos placed into the real plate photo ----------
     The plate's aperture is found in its own photo (the opening is the flat area in the
     middle of the image), each module photo is trimmed to the product itself, and the
     modules are drawn into the opening side by side in slot order. If the browser cannot
     read the image pixels, the plain plate photo is shown instead. */
  var imgCache = {}, infoCache = {}, previewToken = 0;
  function srcAt(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function loadImg(src) {
    if (!imgCache[src]) imgCache[src] = new Promise(function (res, rej) {
      var i = new Image(); i.crossOrigin = 'anonymous';
      i.onload = function () { res(i); }; i.onerror = rej; i.src = src;
    });
    return imgCache[src];
  }
  function pixels(img, maxW) {
    var sc = Math.min(1, maxW / img.naturalWidth), w = Math.max(1, Math.round(img.naturalWidth * sc)), h = Math.max(1, Math.round(img.naturalHeight * sc));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, w, h); x.drawImage(img, 0, 0, w, h);
    return { w: w, h: h, d: x.getImageData(0, 0, w, h).data };
  }
  function diff(d, i, r, g, b) { return Math.max(Math.abs(d[i] - r), Math.abs(d[i + 1] - g), Math.abs(d[i + 2] - b)); }
  /* Silhouette of the product against its photo background, and how mirror-symmetric it is
     left-to-right (0 = perfectly symmetric). A straight-on front photo scores close to 0;
     angled, side and back shots score much higher. */
  function silhouette(P) {
    var w = P.w, h = P.h, d = P.d, r = d[0], g = d[1], b = d[2], x0 = w, x1 = -1, y0 = h, y1 = -1, x, y;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) if (diff(d, (y * w + x) * 4, r, g, b) > 30) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    if (x1 < 0) return null;
    var bad = 0, n = 0;
    for (y = y0; y <= y1; y++) for (x = x0; x < (x0 + x1) / 2; x++) {
      var a = diff(d, (y * w + x) * 4, r, g, b) > 30, c = diff(d, (y * w + (x0 + x1 - x)) * 4, r, g, b) > 30;
      if (a !== c) bad++; n++;
    }
    return { x0: x0, x1: x1, y0: y0, y1: y1, sym: n ? bad / n : 1 };
  }
  function floodRegion(P, sx, sy, tol) {
    var w = P.w, h = P.h, d = P.d, ci = (sy * w + sx) * 4, r = d[ci], g = d[ci + 1], b = d[ci + 2];
    var seen = new Uint8Array(w * h), stack = [sy * w + sx], minX = sx, maxX = sx, minY = sy, maxY = sy, edge = false, cnt = 1;
    seen[sy * w + sx] = 1;
    while (stack.length) {
      var k = stack.pop(), x = k % w, y = (k - x) / w;
      if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y;
      if (x === 0 || y === 0 || x === w - 1 || y === h - 1) { edge = true; break; }
      [k - 1, k + 1, k - w, k + w].forEach(function (nk) {
        if (!seen[nk] && diff(d, nk * 4, r, g, b) <= tol) { seen[nk] = 1; cnt++; stack.push(nk); }
      });
    }
    var bw = maxX - minX + 1, bh = maxY - minY + 1;
    if (edge || bw * bh < w * h * 0.01 || bw * bh > w * h * 0.6) return null;
    return { x0: minX, x1: maxX, y0: minY, y1: maxY, fill: cnt / (bw * bh) };
  }
  /* Perspective check: a straight-on photo has the same outline height at its left and right
     edges (and the same width at top and bottom); an angled shot does not. */
  function keystone(P) {
    var w = P.w, h = P.h, d = P.d, r = d[0], g = d[1], b = d[2], x0 = w, x1 = -1, y0 = h, y1 = -1, x, y;
    var on = function (xx, yy) { return diff(d, (yy * w + xx) * 4, r, g, b) > 30; };
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) if (on(x, y)) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    if (x1 < 0) return 1;
    var W = x1 - x0 + 1, H = y1 - y0 + 1;
    var colSpan = function (xx) { var a = -1, z = -1; for (var yy = y0; yy <= y1; yy++) if (on(xx, yy)) { if (a < 0) a = yy; z = yy; } return a < 0 ? 0 : z - a + 1; };
    var rowSpan = function (yy) { var a = -1, z = -1; for (var xx = x0; xx <= x1; xx++) if (on(xx, yy)) { if (a < 0) a = xx; z = xx; } return a < 0 ? 0 : z - a + 1; };
    var dx = Math.round(W * 0.06), dy = Math.round(H * 0.06);
    return Math.abs(colSpan(x0 + dx) - colSpan(x1 - dx)) / H + Math.abs(rowSpan(y0 + dy) - rowSpan(y1 - dy)) / W;
  }
  /* Finds the plate's opening(s): flat areas seeded along the vertical centre line. One opening
     for single plates, two stacked openings for double-stack plates. */
  function findAperture(img) {
    var P = pixels(img, 480), w = P.w, h = P.h, cx = w >> 1, regs = [], d = P.d;
    [0.5, 0.3, 0.7, 0.22, 0.78, 0.4, 0.6].forEach(function (f) {
      var sy = Math.round(h * f);
      if (regs.some(function (r) { return sy >= r.y0 && sy <= r.y1; })) return;
      /* the opening shows the photo's background, so only seed where the pixel matches it */
      if (diff(d, (sy * w + cx) * 4, d[0], d[1], d[2]) > 40) return;
      /* white plates on white backgrounds need a tighter tolerance so the opening doesn't leak into the background */
      var r = floodRegion(P, cx, sy, 22) || floodRegion(P, cx, sy, 8); if (r) regs.push(r);
    });
    if (!regs.length) return null;
    var area = function (r) { return (r.x1 - r.x0) * (r.y1 - r.y0); };
    regs.sort(function (a, b) { return area(b) - area(a); });
    /* a second opening only counts if it is about as big as the first (double-stack plates) */
    regs = regs.slice(0, 2).filter(function (r, i) { var f = regs[0]; return i === 0 || (area(r) >= area(f) * 0.5 && Math.abs((r.x1 - r.x0) - (f.x1 - f.x0)) <= (f.x1 - f.x0) * 0.25 && r.x0 < f.x1 && r.x1 > f.x0); }).sort(function (a, b) { return a.y0 - b.y0; });
    /* a thin line or shadow across an opening can split it in two: join pieces directly above
       or below that line up with it */
    regs = regs.map(function (r) {
      [1, -1].forEach(function (dir) {
        for (var n = 0; n < 3; n++) {
          var gap = Math.round(h * 0.03), found = null;
          for (var g = 2; g <= gap && !found; g++) {
            var sy = dir > 0 ? r.y1 + g : r.y0 - g;
            if (sy <= 0 || sy >= h - 1 || diff(d, (sy * w + cx) * 4, d[0], d[1], d[2]) > 40) continue;
            var q = floodRegion(P, cx, sy, 22) || floodRegion(P, cx, sy, 8);
            if (q && Math.abs(q.x0 - r.x0) <= (r.x1 - r.x0) * 0.1 && Math.abs(q.x1 - r.x1) <= (r.x1 - r.x0) * 0.1) found = q;
          }
          if (!found) break;
          r = { x0: Math.min(r.x0, found.x0), x1: Math.max(r.x1, found.x1), y0: Math.min(r.y0, found.y0), y1: Math.max(r.y1, found.y1), fill: Math.max(r.fill, found.fill) };
        }
      });
      return r;
    }).filter(function (r, i, all) {
      return !all.slice(0, i).some(function (o) { return r.y0 <= o.y1 && r.y1 >= o.y0; });   /* drop duplicates after joining */
    });
    var U = { x0: Math.min.apply(null, regs.map(function (r) { return r.x0; })), x1: Math.max.apply(null, regs.map(function (r) { return r.x1; })),
              y0: Math.min.apply(null, regs.map(function (r) { return r.y0; })), y1: Math.max.apply(null, regs.map(function (r) { return r.y1; })) };
    var S = silhouette(P), score = 1;
    if (S) {
      var ow = Math.max(1, S.x1 - S.x0), oh = Math.max(1, S.y1 - S.y0);
      score = S.sym + Math.abs((U.x0 - S.x0) - (S.x1 - U.x1)) / ow + Math.abs((U.y0 - S.y0) - (S.y1 - U.y1)) / oh;
      if (ow / oh < 0.4 || (U.x1 - U.x0) / ow < 0.15) score += 5;          /* side view */
      score += 4 * keystone(P);                                              /* angled view */
    }
    /* seen from the back, the opening is criss-crossed by the plate's frame */
    score += Math.max(0, 0.93 - Math.min.apply(null, regs.map(function (r) { return r.fill; }))) * 10;
    var rows = regs.map(function (r) { return { x: r.x0 / w, y: r.y0 / h, w: (r.x1 - r.x0 + 1) / w, h: (r.y1 - r.y0 + 1) / h }; });
    return { x: rows[0].x, y: rows[0].y, w: rows[0].w, h: rows[0].h, rows: rows, score: score };
  }
  function trimModule(img) {
    var P = pixels(img, 300), w = P.w, h = P.h, d = P.d;
    var cs = [0, (w - 1) * 4, ((h - 1) * w) * 4, ((h - 1) * w + w - 1) * 4];
    var r = 0, g = 0, b = 0; cs.forEach(function (i) { r += d[i]; g += d[i + 1]; b += d[i + 2]; }); r /= 4; g /= 4; b /= 4;
    /* White modules on a white background only show their darker opening at the normal
       threshold, so a softer threshold is used when it finds a clearly larger outline. */
    function bbox(thr) {
      var B = { x0: w, x1: -1, y0: h, y1: -1 };
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
        if (diff(d, (y * w + x) * 4, r, g, b) > thr) { if (x < B.x0) B.x0 = x; if (x > B.x1) B.x1 = x; if (y < B.y0) B.y0 = y; if (y > B.y1) B.y1 = y; }
      }
      return B.x1 < 0 ? null : B;
    }
    var area = function (B) { return (B.x1 - B.x0 + 1) * (B.y1 - B.y0 + 1); };
    var B = bbox(30), Bs = bbox(10);
    if (Bs && (!B || area(Bs) > area(B) * 1.5)) B = Bs;
    if (!B || (B.x1 - B.x0) < w * 0.1) return { x: 0, y: 0, w: 1, h: 1, sym: 1, sat: 0 };
    /* Colourfulness: module fronts are plain plastic or metal, while rear photos show
       coloured terminals and wiring, so this helps pick the front photo. */
    var sat = 0, n = 0;
    for (var yy = B.y0; yy <= B.y1; yy += 2) for (var xx = B.x0; xx <= B.x1; xx += 2) {
      var i = (yy * w + xx) * 4; sat += Math.max(d[i], d[i + 1], d[i + 2]) - Math.min(d[i], d[i + 1], d[i + 2]); n++;
    }
    /* Mirror symmetry of brightness inside the outline: a straight-on front photo is close to 0,
       angled, side and rear photos are much higher. */
    var lr = 0, m = 0;
    for (yy = B.y0; yy <= B.y1; yy += 2) for (xx = B.x0; xx <= (B.x0 + B.x1) / 2; xx += 2) {
      var a1 = (yy * w + xx) * 4, a2 = (yy * w + (B.x0 + B.x1 - xx)) * 4;
      lr += Math.abs((d[a1] + d[a1 + 1] + d[a1 + 2]) - (d[a2] + d[a2 + 1] + d[a2 + 2])) / 3; m++;
    }
    return { x: B.x0 / w, y: B.y0 / h, w: (B.x1 - B.x0 + 1) / w, h: (B.y1 - B.y0 + 1) / h, sat: n ? sat / n : 0, lr: m ? lr / m : 99 };
  }
  function info(src, fn) {
    if (!infoCache[src]) infoCache[src] = loadImg(src).then(function (img) { return { img: img, box: fn(img) }; });
    return infoCache[src];
  }
  /* Product photos are often shot at an angle with a straight-on shot further down the
     gallery. These pick the straight-on photo automatically for every product:
     - plate: the photo whose opening is most centred (equal margins left/right, top/bottom);
     - module: the photo whose trimmed outline is closest to its real 25x50mm-per-space shape. */
  var frontCache = {}, markedCache = {};
  function settle(pr) { return pr.then(function (v) { return v; }, function () { return null; }); }
  /* The front-view photo can be set per product in Shopify admin: give that image an alt text
     containing the keyword from the section settings (default "front view"). If none is marked,
     the builder finds the straight-on photo itself. */
  function markedFront(item) {
    if (!FRONT_KEY || !item.handle) return Promise.resolve(null);
    if (!markedCache[item.handle]) markedCache[item.handle] = settle(fetch(ROOT_URL + '/products/' + encodeURIComponent(item.handle) + '.js')
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var m = (prod.media || []).find(function (x) { return (!x.media_type || x.media_type === 'image') && String(x.alt || '').toLowerCase().indexOf(FRONT_KEY) > -1; });
        return m ? (m.src || (m.preview_image && m.preview_image.src) || null) : null;
      }));
    return markedCache[item.handle];
  }
  function frontPlate(p) {
    var key = 'p' + p.vid;
    if (!frontCache[key]) {
      var needRows = rowsFor(p.size);
      frontCache[key] = markedFront(p).then(function (src) {
        if (!src) return null;
        return settle(info(srcAt(src, 800), findAperture)).then(function (r) { return r && r.box && r.box.rows.length >= needRows ? r : null; });
      }).then(function (marked) { return marked || autoFrontPlate(p); });
    }
    return frontCache[key];
  }
  function autoFrontPlate(p) {
      var srcs = (p.images && p.images.length ? p.images : [p.image]).slice(0, 8);
      var needRows = rowsFor(p.size);
      return Promise.all(srcs.map(function (src) { return settle(info(srcAt(src, 800), findAperture)); })).then(function (list) {
        var best = null, bestScore = 1e9;
        list.forEach(function (r, i) {
          if (!r || !r.box || r.box.rows.length < needRows) return;
          /* The first two gallery photos are the front shots; later ones are side/rear views,
             so they are only used when neither of the first two shows the opening. */
          var sc = r.box.score + (i >= 2 ? 0.6 : 0);
          if (sc < bestScore - 0.01 || (best && Math.abs(sc - bestScore) <= 0.01)) { if (sc < bestScore) bestScore = sc; best = r; }
          else if (!best) { bestScore = sc; best = r; }
        });
        if (!best) { best = list.filter(Boolean)[0] || null; }
        if (!best) throw new Error('plate image unreadable');
        return best;
      });
  }
  function frontModule(m) {
    var key = 'm' + m.vid;
    if (!frontCache[key]) frontCache[key] = markedFront(m).then(function (src) {
      return src ? settle(info(srcAt(src, 400), trimModule)) : null;
    }).then(function (marked) { return marked || autoFrontModule(m); });
    return frontCache[key];
  }
  function autoFrontModule(m) {
      var srcs = (m.images && m.images.length ? m.images : [m.image]).filter(Boolean).slice(0, 8);
      var want = (25 * m.spaces) / 50;
      return Promise.all(srcs.map(function (src) { return settle(info(srcAt(src, 400), trimModule)); })).then(function (list) {
        /* The first photo that is a clean straight-on front (symmetrical, not colourful like
           rear terminals/PCBs, and the right shape for its size); otherwise the product's main photo. */
        for (var i = 0; i < list.length; i++) {
          var r = list[i]; if (!r || r.box.lr == null) continue;
          var ar = (r.box.w * r.img.naturalWidth) / Math.max(1, r.box.h * r.img.naturalHeight);
          if (r.box.lr < 8 && r.box.sat < 7 && Math.abs(Math.log(ar / want)) < 0.35) return r;
        }
        return list[0] || list.filter(Boolean)[0] || null;
      });
  }
  function renderPreview() {
    var p = currentPlate();
    var token = ++previewToken;
    if (!p) { els.preview.innerHTML = ''; return; }
    var caption = '<span class="kt-eb__pv-cap"><b>' + esc((p.rangeName + ' ' + plateLabel(p)).trim()) + ' &middot; ' + sizeLabel(p.size) + '</b> &middot; BG ' + esc(p.code) + '</span>';
    var mods = state.picks.map(modById).filter(Boolean);
    var box = els.preview.querySelector('.kt-eb__pv-plate');
    if (!box) { els.preview.innerHTML = '<div class="kt-eb__pv-plate">' + img(p.image, p.title, 800) + caption + '</div>'; box = els.preview.querySelector('.kt-eb__pv-plate'); }
    else { var cap0 = box.querySelector('.kt-eb__pv-cap'); if (cap0) cap0.outerHTML = caption; var cur = box.firstElementChild; if (cur) cur.classList.add('is-loading'); }
    if (!p.image) return;
    Promise.all([frontPlate(p)].concat(mods.map(function (m) { return frontModule(m); })))
      .then(function (res) {
        if (token !== previewToken) return;
        var plate = res[0]; if (!plate) throw new Error('no plate image'); var ap = plate.box, pi = plate.img;
        var c = document.createElement('canvas'); c.width = pi.naturalWidth; c.height = pi.naturalHeight;
        var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height); x.drawImage(pi, 0, 0);
        var nRows = rowsFor(p.size);
        if (ap && mods.length && ap.rows.length >= nRows) {
          var perRow = p.size / nRows, used = 0;
          mods.forEach(function (m, i) {
            var r = res[i + 1]; if (!r || used >= p.size) return;
            var row = Math.floor(used / perRow), col = used % perRow, A = ap.rows[row];
            var sp = Math.min(m.spaces, perRow - col);
            var AX = A.x * c.width, AY = A.y * c.height, AW = A.w * c.width, AH = A.h * c.height;
            var t = r.box, iw = r.img.naturalWidth, ih = r.img.naturalHeight;
            x.drawImage(r.img, t.x * iw, t.y * ih, t.w * iw, t.h * ih, AX + AW * col / perRow, AY, AW * sp / perRow, AH);
            used += m.spaces;
          });
        }
        c.setAttribute('role', 'img');
        c.setAttribute('aria-label', p.title + (mods.length ? ' with ' + mods.map(function (m) { return m.name; }).join(', ') : ''));
        var curEl = box.firstElementChild;
        if (curEl && curEl.tagName !== 'SPAN') box.replaceChild(c, curEl); else box.insertBefore(c, box.firstChild);
      })
      .catch(function () {
        if (token !== previewToken) return;
        var curEl = box.firstElementChild, tmp = document.createElement('div');
        tmp.innerHTML = img(p.image, p.title, 800);
        if (curEl && curEl.tagName !== 'SPAN') box.replaceChild(tmp.firstChild, curEl); else box.insertBefore(tmp.firstChild, box.firstChild);
      });
  }
  function lineRow(image, title, label, price, del, isNew) {
    return '<div class="kt-eb__line' + (isNew ? ' is-new' : '') + '"><span class="kt-eb__line-img">' + img(image, title, 100) + '</span><span><em>' + esc(label) + '</em>' + esc(title) + '</span>' +
      '<span class="kt-eb__line-end"><b>' + money(price) + '</b>' + (del != null ? '<button type="button" class="kt-eb__del" data-del="' + del + '" aria-label="Delete ' + esc(title) + '">Delete</button>' : '') + '</span></div>';
  }
  function setLines() {
    var p = currentPlate();
    if (!p) { els.lines.innerHTML = '<p class="kt-eb__note">Choose a plate to start.</p>'; return; }
    var html = lineRow(p.image, p.title, 'Plate', p.price, null), slot = 1;
    state.picks.forEach(function (id, i) {
      var m = modById(id); if (!m) return;
      var last = slot + m.spaces - 1;
      html += lineRow(m.image, m.title, m.cat + ' · slot ' + (slot === last ? slot : slot + '-' + last), m.price, i, state.flash === i);
      slot = last + 1;
    });
    state.flash = null;
    els.lines.innerHTML = html;
    els.lines.querySelectorAll('[data-del]').forEach(function (btn) {
      btn.addEventListener('click', function () { deleteAt(Number(btn.dataset.del)); });
    });
  }
  /* Group picks into cart lines, keeping slot order (positions inside one plate). */
  function setLinesData() {
    var p = currentPlate(), out = [];
    if (p) out.push({ role: 'plate', vid: p.vid, title: p.title, price: p.price, qty: 1, image: p.image });
    var slot = 1, byId = {};
    state.picks.forEach(function (id) {
      var m = modById(id); if (!m) return;
      var first = slot, last = slot + m.spaces - 1; slot = last + 1;
      var range = first === last ? String(first) : first + '-' + last;
      if (!byId[id]) { byId[id] = { role: 'module', vid: m.vid, title: m.title, price: m.price, qty: 0, slots: [], m: m, image: m.image }; out.push(byId[id]); }
      byId[id].qty++; byId[id].slots.push(range);
    });
    out.forEach(function (l) { if (l.slots) l.slot = l.slots.join(', '); });
    return out;
  }
  function renderSummary() {
    var p = currentPlate(), cap = capacity(), used = usedSpaces();
    renderPreview();
    els.capacity.className = 'kt-eb__capacity' + (cap && used === cap ? ' is-full' : '') + (used > cap && cap ? ' is-over' : '');
    els.capacity.innerHTML = p ? '<span>' + used + ' / ' + cap + ' spaces used</span><span>' + (used > cap ? (used - cap) + ' over' : (cap - used) + ' remaining') + '</span>' : '<span>Choose a plate size</span>';
    els.bar.style.width = cap ? Math.min(100, Math.round(used / cap * 100)) + '%' : '0';
    els.bar.className = used > cap && cap ? 'is-over' : (cap && used === cap ? 'is-full' : '');
    var free = cap - used;
    var blank = blankModule();
    els.fill.hidden = !(p && free > 0 && used > 0 && blank);
    if (blank) els.fill.textContent = 'Fill ' + free + ' empty space' + (free > 1 ? 's' : '') + ' with ' + COLOURS[blank.colour].toLowerCase() + ' blanks (+' + money(blank.price * free) + ')';
    var lines = setLinesData();
    setLines();
    var each = lines.reduce(function (s, l) { return s + l.price * l.qty; }, 0);
    var total = each * state.kitQty;
    els.total.textContent = money(total);
    els.mtotal.textContent = money(total);
    els.kqOut.textContent = state.kitQty;
    els.clear.hidden = !state.picks.length;
    var problem = !p ? 'Choose a plate size to continue.' : (!p.available ? 'This plate is out of stock.' : (used === 0 ? 'Add at least one module.' : (used > cap ? 'Your modules need ' + used + ' spaces but this plate has ' + cap + '. Remove modules or choose a larger plate.' : (used < cap ? 'Fill the ' + free + ' remaining space' + (free > 1 ? 's' : '') + ' (add a module or blanks) to complete the plate.' : ''))));
    var ok = !problem;
    els.add.disabled = !ok || els.add.dataset.busy === '1';
    els.madd.disabled = els.add.disabled;
    els.mbar.hidden = !p;
    if (!els.msg.dataset.sticky) {
      if (problem && p) showMsg(problem, ''); else clearMsg();
    }
  }
  function blankModule() {
    var want = state.colour !== 'all' ? state.colour : defaultColour();
    var blanks = state.modules.filter(function (m) { return m.base === 'EMBLK' && m.available; });
    return blanks.find(function (m) { return m.colour === want; }) || blanks[0];
  }
  function showMsg(text, kind, sticky) {
    els.msg.hidden = false; els.msg.textContent = text;
    els.msg.className = 'kt-eb__msg' + (kind ? ' kt-eb__msg--' + kind : '');
    if (sticky) els.msg.dataset.sticky = '1'; else delete els.msg.dataset.sticky;
  }
  function clearMsg() { els.msg.hidden = true; delete els.msg.dataset.sticky; }

  function renderAll() { renderModules(); renderSummary(); if (state.range) renderSizes(); renderSteps(); }

  /* ---------- Cart ---------- */
  function setId(lines) {
    var sig = (currentPlate() ? currentPlate().vid : 0) + '|' + state.picks.join(',');
    var h = 2166136261;
    for (var i = 0; i < sig.length; i++) { h ^= sig.charCodeAt(i); h = (h * 16777619) >>> 0; }
    return 'eu' + h.toString(36);
  }
  function addToCart() {
    if (els.add.disabled) return;
    var p = currentPlate(), lines = setLinesData(), id = setId(lines);
    var name = KIT_LABEL + ': ' + (p.rangeName + ' ' + plateLabel(p)).trim() + ', ' + sizeLabel(p.size);
    var layout = state.picks.map(function (vid) { return modById(vid).code; }).join(' / ');
    var items = lines.map(function (l) {
      var props = { '_kit': name, '_grid_id': id, '_grid_role': l.role, '_grid_qty': String(l.qty), '_grid_capacity': String(p.size), '_kit_type': 'euro' };
      if (l.role === 'plate') props._layout = layout;
      if (l.slot) props._slot = l.slot;
      return { id: l.vid, quantity: l.qty * state.kitQty, properties: props };
    });
    els.add.dataset.busy = '1'; els.add.disabled = true; els.madd.disabled = true;
    els.add.textContent = 'Adding…';
    fetch(ROOT_URL + '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart'); return d; });
    }).then(function () {
      els.add.textContent = '✓ Added to cart';
      els.viewcart.hidden = false;
      showMsg('Your ' + sizeLabel(p.size) + ' set (' + lines.length + ' items) has been added to your cart.', 'ok', true);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      try { fetch(ROOT_URL + '/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('[data-cart-count], .t4s-count-box, .cart-count-bubble span').forEach(function (n) { n.textContent = c.item_count; });
      }); } catch (e) {}
      setTimeout(function () { els.add.textContent = 'Add configuration to cart'; delete els.add.dataset.busy; renderSummary(); }, 2500);
    }).catch(function (e) {
      delete els.add.dataset.busy;
      els.add.textContent = 'Add configuration to cart';
      showMsg(e.message + ' – nothing was added. Please adjust the quantity or contact us.', 'err', true);
      renderSummary();
    });
  }

  /* ---------- Events ---------- */
  root.querySelectorAll('[data-eb-head]').forEach(function (b) { b.addEventListener('click', function () { openStep(b.dataset.ebHead); }); });
  els.add.addEventListener('click', addToCart);
  els.madd.addEventListener('click', addToCart);
  els.fill.addEventListener('click', function () {
    var b = blankModule(), free = capacity() - usedSpaces();
    for (var i = 0; i < free; i++) state.picks.push(String(b.vid));
    clearMsg(); renderAll();
  });
  els.clear.addEventListener('click', function () { state.picks = []; state.insertAt = null; clearMsg(); renderAll(); });
  root.querySelectorAll('[data-eb-kq]').forEach(function (b) {
    b.addEventListener('click', function () { state.kitQty = Math.min(50, Math.max(1, state.kitQty + Number(b.dataset.ebKq))); renderSummary(); });
  });
  els.search.addEventListener('input', function () { state.q = els.search.value.trim(); renderModules(); });

  /* ---------- Boot ---------- */
  function fetchAll(handle) {
    var all = [];
    function page(n) {
      return fetch(ROOT_URL + '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + n)
        .then(function (r) { return r.json(); })
        .then(function (d) { all = all.concat(d.products || []); return (d.products && d.products.length === 250 && n < 6) ? page(n + 1) : all; });
    }
    return page(1);
  }
  fetchAll(root.dataset.collection).then(function (products) {
    normalise(products);
    if (!state.plates.length) { els.ranges.innerHTML = '<p class="kt-eb__note">No plates found. Check the collection and range settings.</p>'; return; }
    state.open = 'range';
    afterPlateChange();
  }).catch(function () {
    els.ranges.innerHTML = '<p class="kt-eb__note">Sorry, the builder could not load. Please refresh the page.</p>';
  });
}
  document.querySelectorAll('[data-eb-root]').forEach(initEuroBuilder);
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-eb-root]').forEach(initEuroBuilder); });
})();